import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputStyled = styled.input`
  outline: none;
  border: none;
  border-radius: 4px;
  background-color: #2d4071;
  padding: 10px;
  padding-right: 35px;
  color: #fff;
  font-size: 1rem;
  width: 100%;
`;

export const Icon = styled.i`
  position: absolute;
  right: 14px;
  display: flex;
`;
